export default Object.freeze({
  REQUIRED: '-필수: ',
  SELECT: '-선택: ',
  BLACK_LIST: '블랙리스트',
  NO_RESULT: '검색된 문의 내역이 없습니다.',
  COMMON_ALL: '전체',
  TITLE: '회원상세 관리',
  MEMBER_DETAILS: '회원정보',
  ORDER_DETAILS: '주문내역',
  BENEFIT_DETAILS: '혜택내역',
  INQUIRIES_DETAILS: '상담내역',
  POSTS_DETAILS: '게시글내역',
  ACCUMULATIONS_DETAILS: '적립금 내역',
  COUPON_DETAILS: '할인쿠폰 내역',
  ONE_TO_ONE_INQUIRIES_DETAILS: '1:1 문의 내역',
  PRODUCT_REVIEW_DETAILS: '상품평 내역',
  PRODUCT_INQUIRIES_DETAILS: '상품문의 내역',
  MALL_NAME: '쇼핑몰명',
  MEMBER_TYPE: '회원유형',
  MEMBER_GRADE: '회원등급',
  REAL_ORDER_CNT: '실주문건수',
  TOTAL_PAY_AMOUNT: '실결제금액',
  AVAILABLE_ACCUMULATIONS: '사용가능 적립금',
  AVAILABLE_COUPON_COUNT: '보유할인쿠폰',
  AVAILABLE_COUPON_UNIT: '장',
  RECENT_ORDER: '최근 주문',
  ORDER_DATE: '주문일시',
  ORDER_NUMBER: '주문번호',
  PAY_TYPE: '결제수단',
  LAST_PAY_AMOUNT: '실결제금액',
  EMPTY_ORDER_MESSAGE: '주문내역이 없습니다.',
  MORE: '더보기',
  MONETARY_UNIT: '원',
  RECENT_ONE_ON_ONE_INQUIRY: '최근 1:1 문의',
  INQUIRY_DATE: '문의일시',
  INQUIRY_TITLE: '문의제목',
  INQUIRY_CONTENT: '문의 내용',
  INQUIRY_ISSUER: '문의자',
  INQUIRY_ISSUE_TYPE: '문의유형',
  INQUIRY_ASSIGNEE: '담당자',
  PROGRESS_STATUS: '진행상태',
  INQUIRY_PROGRESS_STATUS_ISSUED: '답변대기',
  INQUIRY_PROGRESS_STATUS_IN_PROGRESS: '진행중',
  INQUIRY_PROGRESS_STATUS_ANSWERED: '답변완료',
  EMPTY_ONE_ON_ONE_INQUIRY_MESSAGE: '1:1 문의 내역이 없습니다.',
  RECENT_PRODUCT_INQUIRY: '최근 상품문의',
  EMPTY_PRODUCT_INQUIRY_MESSAGE: '최근 상품문의 내역이 없습니다.',
  PRODUCT_INQUIRY_STATUS_ANSWERED: '답변완료',
  PRODUCT_INQUIRY_STATUS_NOT_ANSWERED: '답변대기',
  MEMBER_TYPE_MALL: '쇼핑몰회원',
  MEMBER_TYPE_PAYCO: '페이코회원',
  MEMBER_TYPE_SYNC_ID: '연동아이디회원',
  MEMBER_TYPE_OPEN_ID: '오픈아이디회원',
  MALL_HEADER_TITLE: '쇼핑몰',
  INQUIRY_SEARCH_TITLE_LABEL: '문의 제목',
  INQUIRY_SEARCH_TITLE_PLACEHOLDER: '검색어 입력',
  INQUIRY_SEARCH_SUBMIT_LABEL: '조회',
  INQUIRY_SEARCH_RESET_LABEL: '초기화',
  INQUIRY_SEARCH_TYPE_AND_ASSIGNEE_LABEL: '문의유형 / 담당자',
  INQUIRY_SEARCH_PERIOD_LABEL: '문의 일시',
  INQUIRY_SEARCH_PROGRESS_LABEL: '진행 상태',
  INQUIRY_ALL_SELECT: '1:1 문의전체',
  INQUIRY_ASSIGNEE_ALL_SELECT: '담당자 전체',
  INQUIRY_SEARCH_RESULT_LABEL: '조회결과',
  INQUIRY_SEARCH_RESULT_UNIT: '건',
  MEMBER_NO: '회원번호',
  MEMBER_NAME: '회원명',
  MEMBER_ID: '아이디',
  NICK_NAME: '닉네임',
  REEVALUATIONS_DATE: '유지일',
  MEMBER_GROUP: '회원그룹',
  CERTIFICATE_STATUS: '인증여부',
  CERTIFICATE_DATE: '인증일',
  CERTIFICATE_MOBILE: '휴대폰인증 완료',
  CERTIFICATE_EMAIL: '이메일인증 완료',
  CERTIFICATE_SMS: 'SMS인증 완료',
  CERTIFICATE_DISAGREE: '미인증',
  ADULT_CERTIFICATE_STATUS: '성인인증 여부',
  CERTIFICATE_ADULT: '성인인증 완료',
  BIRTH_DAY: '생년월일',
  GENDER: '성별',
  PHONE_NUMBER: '전화번호',
  MOBILE_NUMBER: '휴대폰번호',
  BUSINESS_NAME: '회사명',
  BUSINESS_REGISTRATION_NO: '사업자등록번호',
  REFUND_ACCOUNT_INFO: '환불계좌정보',
  REFUND_ACCOUNT_MODIFY: '계좌정보수정',
  REFUND_ACCOUNT_NO: '환불 계좌 번호',
  ACCOUNT_OWNER_NAME: '예금주명',
  EMAIL: 'e메일주소',
  EMAIL_EDIT: '메일주소수정',
  EMAIL_DUPLICATE_CHECK: '중복확인',
  ADDRESS: '주소',
  FIND_ZIP_CODE: '우편번호 찾기',
  SIGN_UP_DATE: '회원가입일',
  SIGN_UP_ROUTE: '가입경로',
  LAST_LOGIN_DATE: '최종로그인',
  MEMBER_COMBINE_INFO: '회원연동 정보',
  SMS_AGREED: 'SMS 수신 동의',
  AGREED: '동의',
  DISAGREED: '미동의',
  REJECT: '거부',
  EMAIL_AGREED: 'e메일 수신 동의',
  PUSH_AGREED: '푸쉬 수신 동의',
  BLACKLIST_STATUS: '블랙리스트 여부',
  BLACKLIST_MEMBER: '블랙리스트 회원',
  PERSONAL_INFO_COLLECT_AGREE: '개인정보 수집/이용',
  PERSONAL_INFO_TREATMENT_AGREE: '개인정보 처리/위탁',
  PERSONAL_INFO_THIRD_OFFER: '개인정보 제3자 제공',
  MEMBER_STATUS: '회원상태',
  RECOMMENDER: '추천인',
  COMMENT: '회원정보 관련 메모',
  GRADE_UPDATE: '등급변경',
  GROUP_UPDATE: '그룹변경',
  SUSPENSION: '이용정지',
  EXPEL_MEMBER: '강제탈퇴',
  TEMPORARY_PASSWORD: '임시 비밀번호 발급',
  SAVE_CHANGES: '변경사항 저장',
  PC_WEB: 'PC웹',
  MOBILE_APP: '모바일앱',
  MOBILE_WEB: '모바일웹',
  WAITING: '가입대기',
  ACTIVE: '가입완료',
  FREEZE: '휴면',
  DORMANT: '휴면',
  PAUSED: '이용정지',
  MALE: '남성',
  FEMALE: '여성',
  SELECT_BANK: '은행선택',
  ASK_CONFIRM_MESSAGE: '수정사항을 저장하시겠습니까?',
  MODIFY_SUCCESS_MESSAGE: '수정완료하였습니다.',
  MODIFY_FAILURE_MESSAGE: '수정 실패하였습니다.',
  REFUND_ACCOUNT_VALID_FAIL_MESSAGE: '환불계좌정보를 입력해 주시기 바랍니다.',
  INVALID_BUSINISS_NAME: '‘”<>\\`는 입력하실 수 없습니다.',
  INVALID_REGISTER_NO: '사업자등록번호는 숫자 10자리로 입력해야 합니다.',
  EMAIL_VALID_FAIL_MESSAGE: '이메일 주소를 입력하세요.',
  EMAIL_DUPLICATED_VALID_FAIL_MESSAGE: '이메일 중복확인이 안되었습니다.',
  EMAIL_EMPTY_MESSAGE: '이메일 주소를 입력하세요.',
  EMAIL_IS_DUPLICATED_MESSAGE: '이메일 중복됨',
  EMAIL_DUPLICATED_CHECKED_MESSAGE: '확인되었습니다.',
  MEMBER_GRADE_UPDATE_POPUP: '회원등급변경팝업',
  MEMBER_GROUP_UPDATE_POPUP: '회원그룹변경팝업',
  USE_COUPON: '사용가능 쿠폰',
  OVER_COUPON: '사용완료 쿠폰',
  PAPER: '장',
  COUPON_NAME: '쿠폰명',
  COUPON_NO: '쿠폰번호',
  USE_NOT_COUPON: '쿠폰 사용여부',
  COUPON_GIVE: '할인쿠폰 지급',
  PLEASE_ENTER_KEYWORD: '검색어를 입력하세요.',
  USABLE: '사용가능',
  USED: '사용완료',
  EXPIRED: '기간만료',
  WITHDRAW: '철회완료',
  GRID_NONE_DISPLAY: '검색된 혜택 내역이 없습니다.',
  WITHDRAW_YMDT: '철회일시',
  WITHDRAW_REASON: '철회사유',
  WITHDRAW_ADMIN_NAME: '쿠폰 철회자',
  WITHDRAW_TTL: '쿠폰 철회',
  WITHDRAW_TITLE: '쿠폰철회',
  ADMIN_ISSUE_REASON: '지급사유',
  COUPON_TYPE: '혜택구분',
  COUPON_USE_STATUS_TYPE: '쿠폰상태',
  ISSUE_ADMIN_NAME: '지급자',
  ISSUE_TYPE: '발급유형',
  REGISTER_ADMIN_NAME: '쿠폰 등록자',
  ISSUE_YMDT: '발급 일시',
  USEEND_YMDT: '유효기간 만료일',
  USE_YMDT: '사용일시',
  USED_YN: '사용여부',
  GIVE_WITHDRAW: '지급철회',
  DETAIL: '상세보기',
  DISCOUNT: '상품 금액 할인',
  CART_DISCOUNT: '장바구니 금액 할인',
  DOWNLOAD: '다운로드 발급',
  CODE_DESIGNATE: '지정코드 발급',
  CODE_RANDOM: '난수코드 발급',
  INSERT: '인서트 발급',
  CODE_DESIGNATE_ADMIN_ONLY: '지정코드 발급(어드민 전용)',
  WITHDRAW_OVER: '쿠폰철회가 완료 되었습니다.',
  SELECT_COUPON: '쿠폰 선택',
  PAYCO_VIP: 'PAYCO회원',
  SEE_ORDER: '주문보기',
  MILEAGE_TITLE: '임직원포인트 내역',
  COUPON_TITLE: '할인쿠폰 내역',
  MILEAGE_PLUS_MINUS: '지급/차감',
  ABAILABLE: '사용가능한',
  NEXT_CANCEL_MILEAGE: '익월 소멸예정',
  DELETE_COUPON_ISSUANCE_HISTORY_1:
    '쿠폰 만료일 이후 미사용 상태로 1년이 경과된 쿠폰의 발급 내역은 삭제되어 조회가 불가합니다.<br>(단, 1인당 + 전체기간 기준으로 발급수량을 제한한 쿠폰에 대한 발급내역은 삭제되지 않습니다.)',
  DELETE_COUPON_ISSUANCE_HISTORY_2: '이에 따라 현황 내 발급건수와 조회결과가 일부 상이할 수 있습니다.',
  DELETE_COUPON_ISSUANCE_HISTORY_3: '내역 관리가 필요하신 경우 삭제 전 엑셀 파일을 별도로 다운받아 관리해주세요.',
  DELETE_COUPON_PAYMENT_HISTORY_1:
    '쿠폰 만료일 이후 미사용 상태로 1년이 경과된 쿠폰의 지급 내역은 삭제되어 조회가 불가합니다.<br>(단, 1인당 + 전체기간 기준으로 발급수량을 제한한 쿠폰에 대한 지급내역은 삭제되지 않습니다.)',
  DELETE_COUPON_PAYMENT_HISTORY_2: '이에 따라 현황 내 지급건수와 조회결과가 일부 상이할 수 있습니다.',
});